import styled from 'styled-components';
import { KeyboardArrowDown } from '@material-ui/icons';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core';


export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    padding: 20px 10px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    width: 320px;
`;



export const TitleContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: space-between;
    width: 100%;
    padding-left: 5px;
    align-items: center;
`;

export const Title = styled.h2`
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
`;

export const ButtonAddUser = styled.button`
    border: none;
    cursor: pointer;
    background-color: transparent;
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px 8px 40px;
  background-color: #f0f2f5;
  border: none;
  border-radius: 8px;
  color: #111b21;
  font-size: 14px;
  transition: background-color 0.2s ease;
  margin-bottom: 10px;
  margin-top: 10px;
  &:focus {
    outline: none;
    background-color: #e4e6e8;
  }

  &::placeholder {
    color: #667781;
  }
`;

export const UserList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    width: 100%;
    overflow-y: auto;
    margin-bottom: 20px;
    gap: 10px;
`;
export const UserItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width:100%;
    padding: 0 10px;
`;

export const UserItemButton = styled.button`
  background-color: #ECEEF2;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 600;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #D9DCE0;
  }
`;
export const LoadingMessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  margin: 12px auto;
  width: 100%;
  height: 100%;
`;

export const LoadingMessage = styled.span`
  font-size: 11px;
  color: #667781;
  float: right;
  margin-left: 8px;
  margin-top: 4px;
`;

export const DropdownMenu = styled.div`
	position: absolute;
	top: 110%;
	right: 16px;
	background-color: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	border: 1px solid #e0e0e0;
	z-index: 10000;
	min-width: 180px;
	opacity: ${props => props.isOpen ? 1 : 0};
	visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
	transform: ${props => props.isOpen ? 'translateY(-50%)' : 'translateY(calc(-50% - 10px))'};
	transition: all 0.2s ease;
  border: 1px solid red;
`;

export const DropdownItem = styled.div`
	padding: 12px 16px;
	cursor: pointer;
	font-size: 14px;
	color: #111b21;
	display: flex;
	align-items: center;
	gap: 12px;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #f5f6f6;
	}

	&:first-child {
		border-radius: 8px 8px 0 0;
	}

	&:last-child {
		border-radius: 0 0 8px 8px;
	}

	&:only-child {
		border-radius: 8px;
	}

	svg {
		width: 18px;
		height: 18px;
		color: #54656f;
	}
`;

export const DropdownOverlay = styled.div`
	position: fixed;
	z-index: 999;
	display: ${props => props.isOpen ? 'block' : 'none'};
`;

export const AnimatedArrowIcon = styled( KeyboardArrowDown )`
  transition: opacity 1.5s ease-in-out;
  opacity: ${( { isHovered } ) => isHovered ? 1 : 0};
  cursor: pointer;
  margin-left: 4px;
	color: #54656f;

  &:hover {
    opacity: 1;
  }
`;
export const GreenSwitch = withStyles( {
	switchBase: {
		color       : '#00a884',
		'&$checked' : {
			color: '#00a884'
		},
		'&$checked + $track': {
			backgroundColor: '#00a884'
		}
	},
	checked : {},
	track   : {}
} )( Switch );
